import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type {
  IRowContainerProps,
  SpecialRowContainerBackgroundT,
} from '../RowContainer.h'

import { LAYOUT, ROW_GAP } from 'vars/index'
import { RowContainer } from '../RowContainer'
import {
  CardsInRow,
  CellsAlignment,
  RowContainerVerticalGaps,
  RowControlsType,
  RowDescriptionType,
  RowPaddings,
  SpecialRowContainerBackground,
} from '../RowContainer.h'

export interface ISpecialRowContainerTemplateProps extends IRowContainerProps {
  cardsInRow?: CardsInRow
  scrollByCardsCount?: number
  cellsAlignment?: CellsAlignment
  children?: JSX.Element[]
  gap?: ROW_GAP
  paddings?: (typeof RowPaddings)[keyof typeof RowPaddings]
  controlsType?: RowControlsType
  title?: string
  buttonTitle?: string
  descriptionType: RowDescriptionType
  description?: string
  backgroundStyle?: SpecialRowContainerBackgroundT
  rowPosterImage?: string
  color?: TextBoxColors
  itemCount: number
}

export const SpecialRowContainerTemplateWithHeader = ({
  cardsInRow = CardsInRow.Horizontal_5,
  selectedItem,
  cellsAlignment: _unused1 = CellsAlignment.Start,
  scrollByCardsCount,
  children,
  gap = ROW_GAP.SIZE_10,
  paddings: _unused2 = RowPaddings.DEFAULT,
  controlsType = RowControlsType.inRowFluid,
  descriptionType = RowDescriptionType.CenteredWithInlineBtn,
  buttonTitle = 'See all',
  description,
  title,
  backgroundStyle = SpecialRowContainerBackground.GradientWithOverlay,
  rowPosterImage,
  containerVerticalGap = RowContainerVerticalGaps.SpecialRowWithHeader,
  verticalPaddingBottom = LAYOUT.VerticalBottomRowPaddings,
  verticalPaddingTop = LAYOUT.VerticalTopRowPaddings,
  verticalMarginTop = LAYOUT.VerticalTopSpecialRowPaddings,
  verticalMarginBottom = LAYOUT.VerticalBottomSpecialRowPaddings,
  titleColor,
  ...rest
}: ISpecialRowContainerTemplateProps): JSX.Element => {
  return (
    <RowContainer
      scrollByCardsCount={scrollByCardsCount}
      cardsInRow={cardsInRow}
      controlsType={controlsType}
      gap={gap}
      containerVerticalGap={containerVerticalGap}
      withSpecialCell={false}
      backgroundStyle={backgroundStyle}
      rowPosterImage={rowPosterImage}
      verticalPaddingBottom={verticalPaddingBottom}
      verticalPaddingTop={verticalPaddingTop}
      verticalMarginTop={verticalMarginTop}
      verticalMarginBottom={verticalMarginBottom}
      description={description}
      buttonTitle={buttonTitle}
      title={title}
      descriptionType={descriptionType}
      titleColor={titleColor}
      selectedItem={selectedItem}
      {...rest}
    >
      {children}
    </RowContainer>
  )
}
